import { OfferBannerState } from '@com-delta-idp/mnx-fast-action-banner-ui';
import {
  DisplayProperties,
  RelatedLinks
} from '@com-delta-idp/mnx-skymiles-shared';
import { Offers } from '../../../features';

export interface Banner extends OfferBannerState, DisplayProperties {}

export interface Earns {
  title: string;
  banner: Banner;
  offers: Offers;
  partners: boolean;
  relatedLinks: RelatedLinks;
}
